angular
  .module("myApp", [
    "ngResource",
    "ngAria",
    "ui.router",
    "ngDialog",
    "ui.bootstrap",
    "ui.bootstrap.datepickerPopup",
    "gettext",
    "ui-notification",
    "ui.select",
    "monospaced.elastic",
    "uniso-data",
    "ngCookies",
    "ngFileUpload",
    "mwl.calendar",
    "ngSanitize",
    "InlineTextEditor",
    "rzModule",
  ])

  .config(($stateProvider, $urlRouterProvider, $httpProvider, NotificationProvider) => {
    // vizuāla verifikācija, ka lints patiešām strādā
    // vienīgais warnings pie make lint
    const lint_safety_check_passed = true

    NotificationProvider.setOptions({
      delay: 5000,
      startTop: 20,
      startRight: 10,
      verticalSpacing: 20,
      horizontalSpacing: 20,
      positionX: "right",
      positionY: "top",
    })

    $urlRouterProvider.otherwise("app/home")
    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {}
    }

    $httpProvider.defaults.headers.get["If-Modified-Since"] = "0"
    const org_contexts = {
      organization_iesniedzejs: true,
      organization_postdoc: true,
      organization_darbinieks: true,
    }

    const nlist_params = [
      "statuss",
      "q",
      "atbildigais",
      "pieteicejs",
      "sort",
      "actionable",
      "sakuma_datums_no",
      "sakuma_datums_lidz",
      "beigu_datums_no",
      "beigu_datums_lidz",
      "next_mp_no",
      "next_mp_lidz",
      "mp_termins_mode",
      "pieteikumu_karta",
      "numbering_mode",
      "vp_no",
      "vp_lidz",
      "gp_no",
      "gp_lidz",
    ]

    $stateProvider
      .state("app", {
        url: "/:context",
        templateUrl: "pages/blank.html",
        controller: "CurrentContextController",
        resolve: {
          serverReady: (forcehttp) => forcehttp.get("/api/auth"),
        },
      })
      .state("app.home", {
        group: "home",
        url: "/home",
        templateUrl: "pages/home/home.html",
        controller: "HomeController",
        controllerAs: "hc",
      })
      .state("app.manager", {
        url: "/manager",
        context: "manager",
        templateUrl: "pages/blank.html",
      })
      .state("app.parole", {
        url: "/parole",
        templateUrl: "pages/blank.html",
      })
      .state("app.parole.kods", {
        url: "/:kods",
        templateUrl: "pages/auth/reset.html",
        controller: "PasswordResetController",
        controllerAs: "ctl",
      })
      .state("app.org-dashboard", {
        group: "home",
        url: "/d",
        templateUrl: "pages/home/dashboard.html",
        controller: "DashboardController",
        // templateUrl: "pages/lists/pp-user-nlist.html",
        // controller: "UserListController",
        controllerAs: "ctl",
      })
      .state("app.about", {
        group: "about",
        url: "/about",
        templateUrl: "pages/about/about.html",
      })
      .state("app.404", {
        group: "404",
        url: "/404",
        templateUrl: "pages/404.html",
      })
      .state("app.codificators", {
        group: "codificators",
        abstract: true,
        url: "/codificators",
        templateUrl: "pages/blank.html",
        controller: "CodificatorController",
        controllerAs: "cc",
      })
      .state("app.codificators.list", {
        group: "codificators",
        url: "/list",
        templateUrl: "pages/codificators/codificator.html",
        controller: "CodificatorController",
        controllerAs: "cc",
        context: "manager",
        level: 0,
      })
      .state("app.codificators.edit", {
        group: "codificators",
        url: "/{id:int}",
        templateUrl: "pages/codificators/codificator_edit.html",
        controller: "CodificatorEditController",
        context: "manager",
        controllerAs: "cce",
      })
      .state("app.expert-application", {
        group: "project_application",
        abstract: true,
        templateUrl: "pages/blank.html",
        url: "/expert-application",
        context: "expert",
      })
      .state("app.expert-application.list", {
        group: "project_application",
        url: "/list",
        templateUrl: "pages/pp/pp-expert-list.html",
        controller: "ExpertApplicationController",
        controllerAs: "ctl",
        context: "expert",
      })
      .state("app.expert-application.edit", {
        group: "project_application",
        url: "/{id:int}/{ekspertize_id:int}?page",
        templateUrl: "pages/pp/pp-expert-edit.html",
        controller: "ExpertApplicationFormController",
        context: "expert",
        controllerAs: "ctl",
      })
      .state("app.mp", {
        group: "mp",
        abstract: true,
        templateUrl: "pages/blank.html",
        url: "/mp",
      })
      .state("app.mp.print", {
        url: "/print",
        templateUrl: "pages/blank.html",
      })
      .state("app.mp.print.by-id", {
        url: "/{id:int}",
        controller: "MaksajumsFormController",
        templateUrl: "pages/mp/print.html",
      })
      .state("app.mp.edit", {
        group: "mp",
        url: "/{id:int}?page",
        templateUrl: "pages/mp/mp-edit.html",
        controller: "MaksajumsFormController",
        controllerAs: "ctl",
        contexts: org_contexts,
      })
      .state("app.mp.edit.open", {
        url: "/edit",
      })
      .state("app.maksajumi", {
        group: "maksajumi",
        abstract: true,
        templateUrl: "pages/blank.html",
        url: "/maksajumi",
      })
      .state("app.maksajumi.list", {
        group: "maksajumi",
        url: "/list",
        templateUrl: "pages/mp/mp-list-iesniegtie.html",
        controller: "MaksajumiMgrListController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.maksajumi.list-all", {
        group: "maksajumi",
        url: "/iesniegtie",
        templateUrl: "pages/mp/mp-list.html",
        controller: "MaksajumiMgrListController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.application", {
        group: "project_application",
        abstract: true,
        templateUrl: "pages/blank.html",
        url: "/project-application",
      })
      .state("app.application.list", {
        group: "project_application",
        url: "/list",
        templateUrl: "pages/pp/pp-list.html",
        controller: "ProjectApplicationController",
        controllerAs: "ctl",
        contexts: org_contexts,
      })
      .state("app.application.list-melnraksti", {
        group: "project_application",
        url: "/melnraksti",
        templateUrl: "pages/pp/pp-list-melnraksti.html",
        controller: "ProjectApplicationController",
        controllerAs: "ctl",
        contexts: org_contexts,
      })
      .state("app.application.list-iesniegtie", {
        group: "project_application",
        url: "/iesniegtie",
        templateUrl: "pages/pp/pp-list-iesniegtie.html",
        controller: "ProjectApplicationController",
        controllerAs: "ctl",
        contexts: org_contexts,
      })
      .state("app.application.edit", {
        group: "project_application",
        url: "/{id:int}?page",
        templateUrl: "pages/pp/pp-edit.html",
        controller: "ProjectApplicationFormController",
        contexts: org_contexts,
        controllerAs: "ctl",
      })
      .state("app.application.edit.latest", {
        group: "project_application",
        url: "/latest",
      })
      .state("app.submissions", {
        group: "submissions",
        abstract: true,
        templateUrl: "pages/blank.html",
        url: "/project-submissions",
      })
      .state("app.submissions.nlist", {
        group: "submissions",
        url: `/nlist?${nlist_params.join("&")}`,
        templateUrl: "pages/lists/pp-mgr-nlist.html",
        controller: "MgrListController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.submissions.list", {
        group: "submissions",
        url: "/list",
        templateUrl: "pages/pp/pp-list-iesniegtie.html",
        controller: "ProjectApplicationMgrController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.submissions.list-all", {
        group: "submissions",
        url: "/iesniegtie",
        templateUrl: "pages/pp/pp-list.html",
        controller: "ProjectApplicationMgrController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.submissions.list-lzp", {
        group: "submissions",
        url: "/lzp",
        templateUrl: "pages/pp/pp-list.html",
        controller: "ProjectApplicationMgrController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.submissions.list-assigned", {
        group: "submissions",
        url: "/assigned",
        templateUrl: "pages/pp/pp-list.html",
        controller: "ProjectApplicationMgrAssignedController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.submissions.edit", {
        group: "submissions",
        url: "/{id:int}?page",
        templateUrl: "pages/pp/pp-edit.html",
        controller: "ProjectApplicationFormController",
        context: "manager",
        controllerAs: "ctl",
      })
      .state("app.files", {
        group: "files",
        abstract: false,
        templateUrl: "pages/files/files.html",
        controller: "PublicFilesController",
        controllerAs: "ctl",
        url: "/faili",
      })
      .state("app.organization", {
        group: "organization",
        abstract: true,
        templateUrl: "pages/blank.html",
        url: "/organization",
      })
      .state("app.organization.list", {
        group: "organization",
        url: "/list",
        templateUrl: "pages/org/org-list.html",
        controller: "OrganizationListController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.organization.edit", {
        group: "organization",
        url: "/{id:int}",
        templateUrl: "pages/org/org-edit.html",
        controller: "OrganizationEditController",
        context: "manager",
        controllerAs: "ctl",
      })
      .state("app.user", {
        group: "user",
        abstract: true,
        templateUrl: "pages/blank.html",
        url: "/user",
      })
      .state("app.user.list", {
        group: "user",
        url: "/list",
        templateUrl: "pages/user/user-list.html",
        controller: "UserListController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.user.list-lzp", {
        group: "user",
        url: "/list-lzp",
        templateUrl: "pages/user/user-list.html",
        controller: "UserListController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.user.list-experts", {
        group: "user",
        url: "/list-experts",
        templateUrl: "pages/user/user-list.html",
        controller: "UserListController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.user.list-org", {
        group: "user",
        url: "/list-org",
        templateUrl: "pages/user/user-list.html",
        controller: "UserListController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.user.edit", {
        group: "user",
        url: "/{id:int}",
        templateUrl: "pages/user/user-edit.html",
        controller: "UserEditController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.manager.templates", {
        group: "templates.manager",
        abstract: true,
        templateUrl: "pages/blank.html",
        url: "/templates",
      })
      .state("app.manager.templates.list", {
        templateUrl: "pages/templates/templates.html",
        controller: "TemplatesManagerController",
        controllerAs: "ctl",
        url: "/list",
      })
      .state("app.calendar", {
        url: "/calendar",
        templateUrl: "pages/calendar/calendar.html",
        controller: "ManagerCalendarController",
        controllerAs: "ctl",
      })
      .state("app.application.print", {
        url: "/print",
        templateUrl: "pages/blank.html",
      })
      .state("app.application.print.by-id", {
        url: "/{id:int}",
        controller: "ProjectApplicationFormController",
        controllerAs: "ctl",
        templateUrl: "pages/pp/print.html",
      })
      .state("app.manager.files", {
        group: "files.manager",
        abstract: true,
        templateUrl: "pages/blank.html",
        url: "/files",
      })
      .state("app.manager.files.list", {
        templateUrl: "pages/files/manager.html",
        controller: "PublicFilesManagerController",
        controllerAs: "ctl",
        url: "/list",
      })
      .state("app.manager.settings", {
        group: "settings",
        abstract: true,
        templateUrl: "pages/blank.html",
        url: "/user",
      })
      .state("app.manager.settings.texts", {
        group: "settings",
        url: "/texts",
        templateUrl: "pages/settings/teksti.html",
        controller: "SettingsTextsController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.manager.settings.submission", {
        group: "settings",
        url: "/submission",
        templateUrl: "pages/settings/pieteikumu-kartas.html",
        controller: "SettingsSubmissionController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.manager.settings.email", {
        group: "settings",
        url: "/email",
        templateUrl: "pages/settings/email.html",
        controller: "SettingsEmailController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.manager.settings.nzdis-export", {
        group: "settings",
        url: "/nzdis-export",
        templateUrl: "pages/settings/nzdis-export.html",
        controller: "SettingsNzdisController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.manager.sent-emails", {
        group: "sent-emails",
        url: "/sent-emails",
        templateUrl: "pages/sent-emails/sent-emails.html",
        controller: "SentEmailsController",
        controllerAs: "ctl",
        context: "manager",
      })
      .state("app.reports", {
        group: "reports",
        url: "/atskaites",
        templateUrl: "pages/blank.html",
        context: "manager",
      })
      .state("app.reports.a10", {
        group: "reports",
        url: "/a10",
        controller: "ReportController",
        controllerAs: "ctl",
        templateUrl: "pages/reports/report.html",
      })
      .state("app.reports.a20", {
        group: "reports",
        url: "/a20",
        controller: "ReportController",
        controllerAs: "ctl",
        templateUrl: "pages/reports/report.html",
      })
      .state("app.reports.a30", {
        group: "reports",
        url: "/a30",
        controller: "ReportController",
        controllerAs: "ctl",
        templateUrl: "pages/reports/report.html",
      })
      .state("app.reports.mp_finansejums", {
        group: "reports",
        url: "/mp-finansejums",
        controller: "ReportController",
        controllerAs: "ctl",
        templateUrl: "pages/reports/mp-finansejums.html",
      })
      .state("app.application.edit.open", {
        url: "/edit",
      })
      .state("app.organization.edit.open", {
        url: "/edit",
      })
      .state("app.user.edit.open", {
        url: "/edit",
      })
  })

  .run(($rootScope, $sce, $q, authentication, uuiData, $filter, $injector, $state, Notification) => {
    $q.all([authentication.promise]).then(() => $(".app-loading").fadeOut("fast"))
    const translate_status = {
      IESNIEGTS: "iesniegts",
      NORAIDITS: "noraidīts",
      MELNRAKSTS: "melnraksts",
      "VAR-IESNIEGT": "iesniedzams",
      "VAR-NORAIDIT": "noraidāms",
    }
    const renderers = {
      virtual_experts: (v, all) => {
        let out
        let s
        out = []
        if (all.lzp_eksperts_statuss) {
          s = `<div class='nowrap' title='${all.ve}'><b>Konsolidētais: ${translate_status[all.lzp_eksperts_statuss]}</b></div>`
          out.push(s)
        }
        if (all.ve_1) {
          if (all.lzp_eksperts_1_statuss) {
            s = `<div class='nowrap'>${all.ve_1}: ${translate_status[all.lzp_eksperts_1_statuss]}</div>`
          } else {
            s = `<div class='nowrap'>${all.ve_1}</div>`
          }
          out.push(s)
        }
        if (all.ve_2) {
          if (all.lzp_eksperts_2_statuss) {
            s = `<div class='nowrap'>${all.ve_2}: ${translate_status[all.lzp_eksperts_2_statuss]}</div>`
          } else {
            s = `<div class='nowrap'>${all.ve_2}</div>`
          }
          out.push(s)
        }
        if (all.experts_hidden) {
          out.push('<div class="arejie-eksperti-info">')
          _(all.experts_hidden).each((e) => {
            if (e.statuss) {
              s = `<div class='nowrap'>${e.vards} ${e.uzvards}: ${translate_status[e.statuss]}</div>`
            } else {
              s = `<div class='nowrap'>${e.vards} ${e.uzvards}</div>`
            }
            out.push(s)
          })
          out.push("</div>")
        }
        if (out) {
          return $sce.trustAsHtml(out.join(""))
        }
        return void 0
      },
    }
    $rootScope.failing = (e) => {
      console.trace()
      return Notification.error(e.data)
    }

    $rootScope.daypickerOptions = {
      datepickerMode: "day",
      showWeeks: false,
      startingDay: 1,
      minDate: "01.01.1901",
      maxDate: "31.12.2099",
      datepickerPopup: "dd.MM.yyyy",
      showButtonBar: false,
      yearFormat: "yyyy",
      closeText: "Aizvērt",
    }
    moment.locale("lv", {
      months:
        "Janvāris/Februāris/Marts/Aprīlis/Maijs/Jūnijs/Jūlijs/Augusts/Septembris/Oktobris/Novembris/Decembris".split(
          "/"
        ),
      monthsShort: "Jan/Feb/Mar/Apr/Mai/Jun/Jul/Aug/Sep/Okt/Nov/Dec".split("/"),
      weekdaysMin: "Sv./Pr./Ot./Tr./Ce./Pk./Se./Sv.".split("/"),
      week: {
        dow: 1,
      },
    })
    $rootScope.settings = {}
    $rootScope.version = CODE_VERSION
    console.log(`Postdoc versija: ${CODE_VERSION}`)
    uuiData.list("public_settings", (s) =>
      _.each(s, (r) => {
        let k
        let v
        k = r.name
        v = r.value
        if (v === "false") {
          $rootScope.settings[k] = false
        } else if (v === "true") {
          $rootScope.settings[k] = true
        } else {
          $rootScope.settings[k] = v
        }
      })
    )
    $rootScope.renderValue = (field, value, meta, custom, allValues) => {
      let filter
      if (custom && field in custom && custom[field]) {
        if (angular.isFunction(custom[field])) {
          return custom[field](value, allValues)
        }
        return custom[field]
      }
      if (field in renderers && renderers[field]) {
        return renderers[field](value, allValues)
      }
      if (meta && meta.type === "boolean") {
        return $filter("formatBool")(value)
      }
      if (meta && (meta.type === "date" || meta.type === "dateTime")) {
        if (meta.type === "date") {
          return $filter("formatDate")(value)
        }
        return $filter("formatDateTime")(value)
      }
      filter = _.camelCase(`format-${field}`)
      if ($injector.has(`${filter}Filter`)) {
        return $filter(filter)(value)
      }
      return value
    }
    $rootScope.percentize = (n, total) => {
      let o
      if (total === 0) {
        return void 0
      }
      if (n === total) {
        return 100
      }
      o = Math.round((n * 100) / total)
      if (o) {
        return o
      }
      return void 0
    }
    $rootScope.percent_amt = (total, n_percent) => {
      if (total === 0) {
        return 0
      }
      if (n_percent === 0) {
        return 0
      }
      if (n_percent === 100) {
        return total
      }
      return Math.round(Math.round((100.0 * total * n_percent) / 100)) / 100
    }
    $rootScope.$on("$stateChangeStart", (event, toState /*, toParams, fromState, fromParams */) => {
      window.document.title = "POSTDOC"
      if (!toState) {
        return
      }
      if (!toState.context) {
        return
      }
      return authentication.require_context(toState.context).catch(() => {
        Notification.error("Nav tiesību piekļūt izvēlētajai sadaļai.")
        return $state.go("app.home")
      })
    })

    authentication.refresh()

    window.na = () => "XXXXX" // s ? s : 'N/A'

    $rootScope.fmtSelectOption = (opt) => {
      let spacer = ""
      if (opt.sadala?.match(/^\d+\.\d+/)) {
        spacer = "    " // nbsp
      }
      return `${spacer}${opt.sadala} ${opt.nosaukums}`
    }
  })

  .controller("AddressTa", ($scope) => {
    $scope.getEntries = (part, typeOfArray) => []
  })

  .config([
    "$controllerProvider",
    ($controllerProvider) => {
      const typeaheads = {
        LigumaSablonsTa: "liguma_sablons_choice",
        VestulesSablonsTa: "vestules_sablons_choice",
        UznemumsTa: "uznemums_choice",
        EkspertsTa: "eksperts_choice",
        LzpEkspertsTa: "lzp_eksperts_choice",
        PostdocTa: "postdoc_choice",
        PieteikumsTa: "pieteikums_choice",
      }
      _.each(typeaheads, (v, k) => {
        $controllerProvider.register(k, function ($scope, uuiData) {
          $scope.getEntries = (part, options, interceptor) => {
            $scope.loading = true
            const params = {
              nosaukums: part,
              limit: 20,
            }
            let result = uuiData.taPromise(v, params)
            if (angular.isFunction(interceptor)) {
              result = result.then(interceptor)
            }
            return result.then((data) => {
              $scope.loading = false
              $scope.entries = data
              return data
            })
          }
          return this
        })
      })
    },
  ])

  .config([
    "$provide",
    ($provide) => {
      const models = {
        JaunsPieteikums: "pp_jauns",
        JaunsPieteikumsMgr: "pp_jauns_mgr",
        PieteikumsSubmit: "pp_submit",
        PieteikumsUnsubmit: "pp_unsubmit",
        PpUserUndoSubmit: "pp_user_undo_submit",
        PpAccept: "pp_accept",
        PpReject: "pp_reject",
        PpImprove: "pp_improve",
        PpPromote: "pp_promote",
        PpUserImprove: "pp_user_improve",
        PpRelock: "pp_relock",
        PpGrantAccess: "pp_grant_access",
        PpRevokeAccess: "pp_revoke_access",
        OrganizationNew: "uznemums_editable",
        OrganizationAddUser: "uzn_add_user",
        OrganizationRemoveUser: "uzn_remove_user",
        PpSendLietvediba: "pp_send_lietvediba",
        PpSaveMaindata: "pp_save_maindata",
        PpSaveDescription: "pp_save_description",
        PpSaveIstenosana: "pp_save_istenosana",
        PpAddPartner: "pp_add_partner",
        PpEditPartner: "pp_edit_partner",
        PpRemovePartner: "pp_remove_partner",
        PpEditDarbiba: "pp_edit_darbiba",
        PpRemoveDarbiba: "pp_remove_darbiba",
        PpEditPublicitate: "pp_edit_publicitate",
        PpRemovePublicitate: "pp_remove_publicitate",
        PpEditProjekts: "pp_edit_projekts",
        PpRemoveProjekts: "pp_remove_projekts",
        PpEditRisks: "pp_edit_risks",
        PpRemoveRisks: "pp_remove_risks",
        PpEditAdrese: "pp_edit_adrese",
        PpRemoveAdrese: "pp_remove_adrese",
        PpSaveValsts: "pp_save_valsts",
        PpSaveUzturesana: "pp_save_uzturesana",
        PpSaveRaditaji: "pp_save_raditaji",
        PpDelete: "pp_delete",
        PpAttachFile: "pp_attach_file",
        PpLzpAttachFile: "pp_lzp_attach_file",
        PpLzpMaksajumuGrafiksSave: "pp_lzp_maksajumu_grafiks_save",
        PpLzpMaksajumuGrafiksRemove: "pp_lzp_maksajumu_grafiks_remove",
        PpAttachContractFile: "pp_attach_contract_file",
        PpRemoveAttachment: "pp_remove_attachment",
        PpSetAttachmentVisibility: "pp_set_attachment_visibility",
        PpRemoveContractAttachment: "pp_remove_contract_attachment",
        PpExpertAttachFile: "pp_expert_attach_file",
        PpExpertRemoveAttachment: "pp_expert_remove_attachment",
        PpExpertEvaluation: "pp_expert_evaluation",
        PpExpertConsolidation: "pp_expert_consolidation",
        PpSaveLaikaGrafiks: "pp_save_laika_grafiks",
        PpSaveFinansejumaPlans: "pp_save_finansejuma_plans",
        PpSaveSaimnFinansejumaPlans: "pp_save_saimn_finansejuma_plans",
        PpSaveBudzetaKopsavilkums: "pp_save_budzeta_kopsavilkums",
        SaveUserOverview: "save_user_overview",
        NewUser: "new_user",
        AssignUserOrg: "assign_user_org",
        UnassignUserOrg: "unassign_user_org",
        PpAssignExpert: "pp_assign_expert",
        PpUnassignExpert: "pp_unassign_expert",
        PpSetKonsolidetajsExpert: "pp_set_konsolidetajs_expert",
        PpAssignResponsible: "pp_assign_responsible",
        PpUnassignResponsible: "pp_unassign_responsible",
        PpSaveLzpMeta: "pp_save_lzp_meta",
        PpRevertExpert: "pp_revert_expert",
        PpRevertExpertConsolidation: "pp_revert_expert_consolidation",
        PpNewVidusposms: "pp_new_vidusposms",
        PpVidusposmsAttachFile: "pp_vidusposms_attach_file",
        PpVidusposmsLzpAttachFile: "pp_vidusposms_lzp_attach_file",
        PpVidusposmsLzpRemoveAttachment: "pp_vidusposms_lzp_remove_attachment",

        PpNewGalaposms: "pp_new_galaposms",
        PpGalaposmsAttachFile: "pp_galaposms_attach_file",
        PpGalaposmsLzpAttachFile: "pp_galaposms_lzp_attach_file",
        PpGalaposmsLzpRemoveAttachment: "pp_galaposms_lzp_remove_attachment",

        PpChangeRawStatus: "pp_change_raw_status",
        ParolesAtjaunosana: "paroles_atjaunosana",
        ParolesNomaina: "paroles_nomaina",
        ParolesNomainaKods: "paroles_nomaina_kods",
        EpastaTests: "epasta_tests",
        ChangeSetting: "change_setting",
        ExportNzdis: "export_nzdis",
        SetNzdisExportSettings: "set_nzdis_export_settings",
        PublicFileUpload: "publiskais_fails_save",
        PublicFileRemove: "publiskais_fails_remove",
        TemplateFileUpload: "sablons_save",
        TemplateFileRemove: "sablons_remove",
        DocumentCreate: "document_save",
        DocumentSave: "document_save",
        DocumentRemove: "document_remove",
        DocumentPublish: "document_publish",
        DocumentUnpublish: "document_unpublish",
        DocumentRegen: "document_regen",

        LzpEkspertaVertejumsSet: "lzp_eksperta_vertejums_set",
        LzpEkspertaVertejumsSubmit: "lzp_eksperta_vertejums_submit",
        LzpKonsolidetaisVertejumsSet: "lzp_konsolidetais_vertejums_set",
        LzpKonsolidetaisVertejumsSubmit: "lzp_konsolidetais_vertejums_submit",

        MpJauns: "mp_jauns",
        MpSaveMaindata: "mp_save_maindata",
        MpSaveIstenosana: "mp_save_istenosana",
        MpEditProblema: "mp_edit_problema",
        MpRemoveProblema: "mp_remove_problema",
        MpSavePasakumi: "mp_save_pasakumi",
        MpEditIepirkumaLigums: "mp_edit_iepirkuma_ligums",
        MpRemoveIepirkumaLigums: "mp_remove_iepirkuma_ligums",
        MpEditDarbaLigums: "mp_edit_darba_ligums",
        MpRemoveDarbaLigums: "mp_remove_darba_ligums",
        MpSaveIznakumaRaditaji: "mp_save_iznakuma_raditaji",
        MpSaveRezultataRaditaji: "mp_save_rezultata_raditaji",
        MpSaveMerkis: "mp_save_merkis",
        MpAttachFile: "mp_attach_file",
        MpRemoveAttachment: "mp_remove_attachment",
        MpSaveCfla: "mp_save_cfla",
        MpRemoveIzdevums: "mp_remove_izdevums",
        MpEditIzdevums: "mp_edit_izdevums",
        MpRemoveStdIzdevums: "mp_remove_std_izdevums",
        MpEditStdIzdevums: "mp_edit_std_izdevums",
        MpRemoveNatura: "mp_remove_natura",
        MpEditNatura: "mp_edit_natura",

        MpSubmit: "mp_submit",
        MpUnsubmit: "mp_unsubmit",
        MpImprove: "mp_improve",
        MpSetStatus: "mp_set_status",
        MpAccept: "mp_accept",
        MpReject: "mp_reject",
        MpDelete: "mp_delete",
        MpSaveKopsavilkums: "mp_save_kopsavilkums",
        MpSaveLzpKopsavilkums: "mp_save_lzp_kopsavilkums",
        MpRefreshKopsavilkums: "mp_refresh_kopsavilkums",
        MpChangeRawStatus: "mp_change_raw_status",

        CalendarEventSave: "calendar_event_save",
        CalendarEventRemove: "calendar_event_remove",

        PieteikumuKartaEdit: "pieteikumu_karta_edit",
        PieteikumuKartaRemove: "pieteikumu_karta_remove",

        TextSave: "cms_text_save",

        EkspertizeRemove: "ekspertize_remove",
        EkspertizeCreate: "ekspertize_create",
        EkspertizeFixup: "ekspertize_fixup",
        RiskuIzvertejumsSave: "risku_izvertejums_save",
        RiskuIzvertejumsDelete: "risku_izvertejums_delete",

        PpSetInactive: "pp_set_inactive",
      }

      _.each(models, (v, k) => {
        $provide.factory(k, ($resource) => {
          return $resource(
            `./data/${v}/:id`,
            { id: "@id" },
            {
              create: { method: "POST" },
              save: { method: "POST" },
            }
          )
        })
      })
    },
  ])

  .filter("moment", () => (input, format) => {
    if (input) {
      return moment(input).format(format ? format : "DD.MM.YYYY HH:mm")
    }
  })

  .filter("autonumber", ($filter, $sce) => (input) => {
    if (input) {
      const parts = $filter("number")(input, 2)
        .split(",")
        .map((x) => x.replace(".", ","))
      // return $sce.trustAsHtml('<span class="number"><span>' + parts.join('</span><span>') + '</span>');
      return parts.join(" ")
    }
  })

  .filter("filename", () => (input) => {
    if (input) {
      return input.toLowerCase().replace(/[^a-zA-Z.\d_]+/g, "-")
    }
  })

  .controller("CurrentContextController", (authentication, $state, $stateParams, Notification) => {
    if ($state.current.context) {
      return authentication.require_context($state.current.context).catch(() => {
        Notification.error("Nav tiesību")
        $state.go("app.home")
      })
    }
    if ($stateParams.context === "app") {
      return
    }
    return authentication.when_ready(() => {
      if (authentication.u.contexts[$stateParams.context]) {
        authentication.set_context($stateParams.context)
      } else {
        $state.go("app.home")
      }
    })
  })

  .filter(
    "improveText",
    ($sce) => (v) => (v ? $sce.trustAsHtml(`<p>${v.replace(/</g, "&lt;").replace(/\n/g, "<br>")}</p>`) : "")
  )

  .filter("formatStatuss", ($sce) => {
    const statusMeta = {
      MELNRAKSTS: {
        text: "Melnraksts",
        cls: "label-default",
      },
      "MELNRAKSTS-LABOJUMS": {
        text: "Labojuma melnraksts",
        cls: "label-labojums",
      },
      "MELNRAKSTS-VIDUSPOSMS": {
        text: "Vidusposms, sagatavošanā",
        cls: "label-labojums",
      },
      "MELNRAKSTS-GALAPOSMS": {
        text: "Gala atskaite, sagatavošanā",
        cls: "label-labojums",
      },
      NEAKTUALS: {
        text: "Precizēts",
        cls: "label-muted",
      },
      PROMOTED: {
        text: "Pārcelts uz pilno plūsmu",
        cls: "label-muted",
      },
      IESNIEGTS: {
        text: "Iesniegts",
        cls: "label-warning",
      },
      NORAIDITS: {
        text: "Noraidīts",
        cls: "label-danger",
      },
      DZESTS: {
        text: "XXX dzēsts XXX",
        cls: "label-danger",
      },
      IZSKATITS: {
        text: "Izskatīts",
        cls: "label-primary",
      },
      APSTIPRINATS: {
        text: "Apstiprināts",
        cls: "label-success",
      },
      SAMAKSATS: {
        text: "Samaksāts",
        cls: "label-success",
      },
      LZP_OK: {
        text: "LZP apstipr.",
        cls: "label-primary",
      },
      IZSKATISANA: {
        text: "Izskatīšanā",
        cls: "label-primary",
      },
      "NETIKS-ISTENOTS": {
        text: "Netiks īstenots",
        cls: "label-muted",
      },
      TEHNISKIE: {
        text: "Tehniskie grozījumi",
        cls: "label-primary",
      },
    }

    return (v, prefix = "") => {
      if (v === null) {
        v = "MELNRAKSTS"
      }
      const meta = statusMeta[v] || {
        text: v,
        cls: "label-primary",
      }
      const p = prefix ? `${prefix} · ` : ""
      return $sce.trustAsHtml(`<span class="label status-label ${meta.cls}">${p}${meta.text}</span>`)
    }
  })

  .filter("formatLzpEkspertsStatuss", ($sce) => {
    const cache = {}
    return (v) => {
      if (v === null) {
        return ""
      }
      if (cache[v]) {
        return cache[v]
      }
      let tmp
      if (v === "MELNRAKSTS") {
        tmp = '<span class="label status-label label-default">' + "Melnraksts" + "</span>"
      } else if (v === "IESNIEGTS") {
        tmp = '<span class="label status-label label-warning">' + "Iesniegts" + "</span>"
      } else if (v === "NORAIDITS") {
        tmp = '<span class="label status-label label-danger">' + "Noraidīts" + "</span>"
      } else {
        tmp = `<span class="label status-label label-primary">${v}</span>`
      }
      cache[v] = $sce.trustAsHtml(tmp)
      return cache[v]
    }
  })

  .filter("formatEkspertsStatuss", ($sce) => {
    const cache = {}
    return (v) => {
      let tmp
      if (v === null) {
        return ""
      }
      if (cache[v]) {
        return cache[v]
      }
      if (v === "MELNRAKSTS") {
        tmp = '<span class="label label-default">' + "Melnraksts" + "</span>"
      } else if (v === "IESNIEGTS") {
        tmp = '<span class="label label-warning">' + "Iesniegts" + "</span>"
      } else if (v === "IESNIEDZAMS") {
        tmp = '<span class="label label-default">' + "Iesniedzams" + "</span>"
      } else {
        tmp = `<span class="label label-primary">${v}</span>`
      }
      cache[v] = $sce.trustAsHtml(tmp)
      return cache[v]
    }
  })

  .config([
    "calendarConfig",
    (calendarConfig) => {
      // View all available config
      moment.locale("lv")

      calendarConfig.dateFormatter = "moment"
      calendarConfig.allDateFormats.moment.date.hour = "HH:mm"
      calendarConfig.allDateFormats.moment.title.day = "ddd D MMM"
      calendarConfig.allDateFormats.moment.title.week = "{year}. gada {week}. nedēļa"
      calendarConfig.i18nStrings.weekNumber = "{week}. nedēļa"
    },
  ])
